class RichText extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('[data-rich-text-toggle]');
    this.wrapper = this.querySelector('[data-rich-text-content]');
    if (!this.trigger || !this.wrapper) return;
    this.content = this.wrapper.querySelector('[data-rich-text]');
    this.maxHeight = +this.wrapper.dataset.richTextContent;
    window.addEventListener('on:debounced-resize', this.checkDescription.bind(this));
    window.addEventListener('load', this.checkDescription.bind(this));
    this.trigger.addEventListener('click', () => {
      const isExpanded = this.ariaExpanded;
      const scrollIntoView = () => {
        this.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        });
        this.wrapper.removeEventListener('transitionend', scrollIntoView);
      };
      this.wrapper.classList.toggle('show_text');
      this.wrapper.addEventListener('transitionend', scrollIntoView);
      if (isExpanded == 'true') {
        this.ariaExpanded = false;
      }
      else {
        this.ariaExpanded = true;
      }
    });
    document.addEventListener('shopify:section:load', () => {
      this.checkDescription();
    });
  }
  checkDescription() {
    const elementHeight = this.content.clientHeight;
    if (this.maxHeight > elementHeight) {
      this.trigger.classList.add('hidden');
      this.wrapper.classList.remove('truncate');
    }
    else {
      this.trigger.classList.remove('hidden');
      this.wrapper.classList.add('truncate');
    }
  }
}
if (!customElements.get('rich-text')) {
  customElements.define('rich-text', RichText);
}
//# sourceMappingURL=rich-text-collapsible.js.map
